import { createSlice } from "@reduxjs/toolkit";

const initialState: ILoginBooking = {
  orgunit: "",
  bookingNumber: "",
  bookingUsername: "",
  orderId: 0,
  agencyId: "",
  customerId: 0,
  isUsernameCorrect: false,
  isAgencyBooking: false,
  isExpired: false,
  isCanceled: false,
  isTcBooking: false,
  canContact: false,
  shouldConfirmEmail: false,
  bookingOverview: {
    orderNo: "",
    fullName: "",
    email: "",
    bookingStatus: "",
  },
  bookingRemarks: [],
  bookingFlights: [],
  bookingHotels: [],
  bookingUpgrades: {
    hasTransferUpgrade: false,
    transferPerPerson: "",
    transferDbPrice: "",
    transferUpgradeCondition: "",
    transferPax: "",
  },
  travelAgency: {
    addressLine: "",
    street: "",
    streetNo: "",
    postalCode: "",
    city: "",
    phoneBusiness: "",
    email: "",
  },
  bookingDetails: {
    travelParticipatns: [],
    holidayDestinations: [],
    travelPeriod: "",
  },
  payment: {
    downPaymentAmount: "",
    downPaymentDueDate: "",
    downPaymentStatus: "",
    finalPaymentAmount: "",
    finalPaymentDueDate: "",
    finalPaymentStatus: "",
    totalPrice: "",
    totalPayment: "",
    openAmount: "",
    immediatelyPayments: [],
    receipts: [],
    paymentTxt: "",
    currency: "",
    displayedCurrency: "",
  },
  transfers: {
    serviceDescriptions: [],
    accomodationCode: "",
    departureDescription: "",
    returnDescription: "",
    pickupTime: "",
    pickupDate: "",
    pickupDesc: "",
  },
  hasOpenedTask: false,
  messages: [],
};

const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    setBookingData: (state, action) => {
      return action.payload;
    },
  },
});

export const bookingActions = bookingSlice.actions;

export default bookingSlice;
